import React from 'react';
import { useField } from 'react-final-form';
import { TextField } from 'housecall-ui';

import { getErrorMessage, hasError } from './utils';

type Props<T> = Omit<React.ComponentProps<typeof TextField>, 'value' | 'onChange' | 'onBlur' | 'onFocus' | 'error'> & {
  name: T;
};

// NOTE: This component is a copy-paste from `components/BillPay/Shared/Components/FormField.tsx`
export const FormField = <T extends string>({ name, label, helperText, ...restTextFieldProps }: Props<T>) => {
  const { input, meta } = useField(name);

  return (
    // data-test-id provided via restTextFieldProps
    <TextField
      {...input}
      label={label}
      helperText={getErrorMessage(meta, helperText)}
      error={hasError(meta)}
      {...restTextFieldProps}
    />
  );
};
